export default __webpack_public_path__ + "static/media/icon_reload.7472516d.svg";